function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Camada_1",
  "data-name": "Camada 1",
  stroke: "none"
}, /*#__PURE__*/React.createElement("path", {
  id: "Pfad_420",
  "data-name": "Pfad 420",
  d: "M12.607,2.292H9.523L8.377,0H4.23L3.084,2.292H0V3.438H1.146v8.833l1.482,1.482H9.979l1.482-1.482V3.438h1.146ZM4.938,1.146h2.73l.573,1.146H4.365ZM10.315,11.8l-.81.81H3.1l-.81-.81V3.438h8.022Z"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rechteck_451",
  "data-name": "Rechteck 451",
  width: 1.146,
  height: 5.73,
  transform: "translate(3.438 5.157)"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rechteck_452",
  "data-name": "Rechteck 452",
  width: 1.146,
  height: 5.73,
  transform: "translate(5.73 5.157)"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rechteck_453",
  "data-name": "Rechteck 453",
  width: 1.146,
  height: 5.73,
  transform: "translate(8.022 5.157)"
}));

function SvgDelete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Delete",
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.607,
    height: 13.753,
    viewBox: "0 0 12.607 13.753",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.2a1ce7f8.svg";
export { ForwardRef as ReactComponent };